import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import terminology from 'javascripts/terminology';

export class ReleasePhaseName extends Field {
  static subqueriesForModel() {
    return { releasePhase: ['name'] };
  }

  get title() {
    return `${terminology('Release phase')} name`;
  }

  exampleContents(): FieldContentsData {
    return { text: `Example ${terminology('release phase')}` };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.releasePhase) {
      return { text: record.releasePhase.name };
    }

    return {};
  }
}
